<!-- 由 suu 创建于 2022-05-05 星期四 -->
<template>
  <div class="ques-pro">
    <div class="p-left" v-show="cur > 0" @click="handelLast">上一题</div>
    <div class="p-region">
      <div class="p-cur" :style="{ width: proWidth }"></div>
    </div>
    <div class="p-right">
      {{ (cur + 1) | handleDate }}/{{ total | handleDate }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-pro',

  components: {},

  props: {
    cur: {}, // 当前题下标
    total: {} // 总题数
  },

  data() {
    return {}
  },

  computed: {
    proWidth() {
      return parseFloat((((this.cur + 1) / this.total) * 100).toFixed(2)) + '%'
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 上一题
    handelLast() {
      this.$emit('on-last')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-pro {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  .p-left {
    min-width: 48px;
    font-size: 16px;
    color: #262f44;
    font-weight: 500;
  }
  .p-region {
    width: 180px;
    height: 8px;
    background: #e8e9ef;
    border-radius: 14px;
    position: relative;
    overflow: hidden;
    margin: 0 26px;
    .p-cur {
      width: 0%;
      height: 100%;
      border-radius: 14px;
      background: #3c3b64;
      transition: width linear 0.5s;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .p-right {
    font-size: 15px;
    font-weight: 500;
    color: #bdbfc6;
  }
}
</style>
